import {event} from '../modules/event';
import {ajax} from '../modules/ajax';
import {comeToFavPopup} from '../modules/comeToFavPopup';

/*
* Голосовалка в:
* - фильмах;	 type === 'movies'
* - рецензиях;   type = 'review'
* - трейлкрах;   type = 'video'
*
* если тип "video", то пишем по id трейлера - videoid
 * если тип "video", то пишем по id трейлера - videoid
 * если тип "review" - пишем по id рецензии - reviewid
 *
*
* TODO cделать универсально
*
* */


export default class {
	constructor(wrapper) {
		this._createElements(wrapper);
		this._addEvents();
        this._addToGlobal();
	}

	_createElements(wrapper){
		this.wrapper = wrapper;
		this.data = JSON.parse(this.wrapper.getAttribute('data-param'));
		this.box = this._getBox();
		this.btnAll = this.box.querySelectorAll('[data-vote-btn]');
		this.countYes = this.box.querySelector('[data-vote-count="yes"]');
		this.countNo = this.box.querySelector('[data-vote-count="no"]');
        this.telegramLink = document.querySelector('[data-telegramLink]');
		this.isSending = false;
		this.ajaxPath = this._defineAjaxPath();
		this.key = this._defineKey();
	}

	_getBox(){
		if(this.wrapper.hasAttribute('data-vote-box')) return this.wrapper;
		else return this.wrapper.querySelector('[data-vote-box]');
	}

	_defineAjaxPath(){
        var self = this,
			part = APP.vars.isDev ? '/_src/layouts' : '',
			part2 = function(){
				if(self.data.type === 'movies') return '/movies/'+ self.data.uid +'/come/';
				else if(self.data.type === 'video') return '/movies/'+self.data.movieid+ '/video/' + self.data.videoid +'/vote';
				else if(self.data.type === 'review') return '/movies/'+ self.data.movieid +'/reviews/'+ self.data.reviewid +'/vote';
			}();

		return	part + part2;
	}

	_defineKey(){
		if(this.data.type === 'movies') return this.data.uid;
		else if(this.data.type === 'video') return this.data.videoid;
		else if(this.data.type === 'review') return this.data.reviewid;
	}

	_addEvents(){

		var self = this;
		for(var i=0, j=this.btnAll.length; i<j; i++){
			event.add(this.btnAll[i], 'click', function(e){

				if (APP.vars.isMobile) {
					if (!APP.auth.tryAuth()) return false;
				} else if (!regAuthObj.isAuth) {
					regAuthObj.authForm.showPopup();
					return false;
				}

				self._sendAjax.call(self, e, this.getAttribute('data-vote-btn'));
			});
		}
	}

	_sendAjax(e, val){
		e.preventDefault();
		e.stopPropagation();

		if(this.isSending) return false;
		this.isSending = true;

		let self = this;

		ajax({
			data: {"vote":val},
			url: this.ajaxPath,
			callback: function(msg){
				self._checkMsg.call(self, msg);

                if ( val && self.telegramLink ) {
                    self.wrapper.parentNode.insertBefore(self.telegramLink, self.wrapper.nextSibling);
                    //self.wrapper.appendChild(self.telegramLink);
				}
			}
		});
	}

    _checkMsg(msg){
		var msg = JSON.parse(msg);

		if (msg.auth === false) {
			if (APP.vars.isMobile) {
				alert('Вам нужно авторизоваться повторно.');
			} else {
				uPopup({
					content: 'Вам нужно авторизоваться повторно.',
					oncloseBefore: function oncloseBefore() {
						location.replace(location.protocol + '//' + location.host + location.pathname);
					}
				});
			}
		} else if (!msg.status) {
			if (APP.vars.isMobile) {
				alert(msg.message);
			} else {
				uPopup({
					content: msg.message
				});
			}
		} else this._addVote(msg);

		this.isSending = false;
	}

    _addVote (msg) {
		/*
		* Применяем ответ сразу ко всем одинаковым id
		* Смотрим, есть ли в ответе fav: true
		* Если есть - это значит, что пользователь нажал "Пойду"
		* В таком случаем фильм автоматом добавляется на сервере в избранное
		* На клиенте остается закрасить сердечко
		* Если есть в ответе hint:true - показываем подсказку о добавлении в избранное
		*
		* */

        var key = this.key,
            type = this.data.type,
            all = window.GLOBALS[type + 'VoteAll'][key];

        for (var i = 0, j = all.length; i < j; i++) {
            var obj = all[i];

            if (obj.countYes) {
                obj.countYes.innerHTML = msg.data.yes;
                obj.countNo.innerHTML = msg.data.no;
            }

            var className = obj.box.className.replace(/js-vote-(yes|no)/g, '');
            if (msg.data.mark) className += ' js-vote-' + msg.data.mark;

            obj.box.className = className;
            //если задали функию успешного выполнения скрипта, запускаем
            //НО!!! запускаем только у текущего объекта
            if (obj.successExec && (obj === this)) obj.successExec();
        }

		if(msg.data.fav) this._addFav();
		if(msg.data.hint) this._addHint(msg.data);

        // analytics
        this._sendStat();
    }

	_addFav() {
		/*
		 * Добавляем в избранное
		 * На данный момент добавляем только фильм, если пользователь нажал пойду
		 * поэтому проверяем на всякий случай тип голосовалки
		 * */
		var type = this.data.type;
		if (type !== 'movies') return;

		try{(window.GLOBALS[type + 'FavAll']['uid-' + this.key][0].addToFav())} catch(e){
			console.log(e);
		}
	} 

	_addHint(data){
		if(!APP.objects.comeToFavPopup) {APP.objects.comeToFavPopup = comeToFavPopup()}
		APP.objects.comeToFavPopup.show(this.box, data);
	}

    _sendStat(){
        if ( this.data.type === 'movies' ){
            try {
                gtag('event', 'click', {
                    'event_category': 'engagement',
                    'event_label': 'movie_go_or_not'
                });
                console.log('gtag success!');
            } catch (error){
                console.error('gtag error:', error);
            }
        } else if( this.data.type === 'review' ) {
            try {
                gtag('event', 'click', {
                    'event_category': 'engagement',
                    'event_label': 'user_review_like_or_dislike'
                });
                console.log('gtag success!');
            } catch (error){
                console.error('gtag error:', error);
            }
        } else if( this.data.type === 'video' ) {
            try {
                gtag('event', 'click', {
                    'event_category': 'engagement',
                    'event_label': 'trailer_like_or_dislike'
                });
                console.log('gtag success!');
            } catch (error){
                console.error('gtag error:', error);
            }
        } else {
            console.error('gtag unknow type');
        }
    }

    _addToGlobal (){
        var key = this.key;
        var type = this.data.type;

        if(!window.GLOBALS) window.GLOBALS = {};
        if(!window.GLOBALS[type+'VoteAll']) window.GLOBALS[type+'VoteAll'] = {};
        if(!window.GLOBALS[type+'VoteAll'][key]) window.GLOBALS[type+'VoteAll'][key] = [];

        window.GLOBALS[type+'VoteAll'][key].push(this);
    }

    del(){
        var key = this.key,
            type = this.data.type,
            all = window.GLOBALS[type+'VoteAll'][key];

        for(var i= 0,j=all.length; i<j; i++){
            if(all[i] === this) {
                all.splice(i, 1);
                if(!all.length) delete window.GLOBALS[type+'VoteAll'][key];
                return false;
            }
        }
    }
}







































